import { useAverageSessionsPerVisitor } from '@va/dashboard/api-client/visitor-stats';
import { useSessionMetricsFilters } from '@va/dashboard/shared/filters';
import { useTranslate } from '@va/localization';
import { FiltersContextProvider } from '@va/shared/feature-filters';
import { TimePeriod } from '@va/types/time';
import { DateComparisonPeriod } from '@va/ui/components/report-block';
import { useCurrentVisitorStatsParams, usePreviousVisitorStatsParams } from '../expandable-rb/useVisitorStatsParams';
import { VisitorStatsReport } from '../expandable-rb/VisitorStatsReport';
import { AVERAGE_SESSIONS_PER_VISITOR_FILE_NAME } from './constants';

const useCurrent = (unit: TimePeriod = TimePeriod.day) => {
  const params = useCurrentVisitorStatsParams();
  return useAverageSessionsPerVisitor({ ...params, unit });
};
const usePrevious = (activeComparisonOption: DateComparisonPeriod, unit: TimePeriod = TimePeriod.day) => {
  const params = usePreviousVisitorStatsParams(activeComparisonOption);
  return useAverageSessionsPerVisitor({ ...params, unit });
};

const UserSessionsCard = ({
  id,
  gridPosition,
  canExpand,
}: {
  id: string;
  gridPosition: number;
  canExpand?: boolean;
}) => {
  const translate = useTranslate();
  const { allFilters } = useSessionMetricsFilters();

  return (
    <FiltersContextProvider allFilterOptions={allFilters} reportBlockId={id}>
      <VisitorStatsReport
        id={id}
        gridPosition={gridPosition}
        canExpand={canExpand}
        fetchCurrentHook={useCurrent}
        fetchPreviousHook={usePrevious}
        title={translate('latestVisitorsOverview.chart.sessionsPerUser.title')}
        titleTooltip={translate('latestVisitorsOverview.axisTimeFrame.sessionsPerUser.tooltip')}
        showTimePeriodFilter
        exportFileName={AVERAGE_SESSIONS_PER_VISITOR_FILE_NAME}
      />
    </FiltersContextProvider>
  );
};

export default UserSessionsCard;
